export var orderPartners = [
    { src: '/storage/img/partner-logos/kawa-i-lawa.png', restaurantName: 'Kawa i Ława' },
    { src: '/storage/img/partner-logos/boru.png', restaurantName: 'Boru Ramen Shop' },
    { src: '/storage/img/partner-logos/ciacho-bez-cukru.jpg', restaurantName: 'Ciacho Bez Cukru' },
    { src: '/storage/img/partner-logos/chisza.jpg', restaurantName: 'Chisza' },
    { src: '/storage/img/partner-logos/czarna-owca.jpg', restaurantName: 'Czarna Owca Gastro Pub' },
    { src: '/storage/img/partner-logos/studnia.png', restaurantName: 'Studnia' },
    { src: '/storage/img/partner-logos/sielsko-anielsko.png', restaurantName: 'Sielsko Anielsko' },
    { src: '/storage/img/partner-logos/zielony-talerzyk2.png', restaurantName: 'Zielony Talerzyk', addonClass: 'logo-long' },
    { src: '/storage/img/partner-logos/biesy.png', restaurantName: 'Biesy' },
    { src: '/storage/img/partner-logos/zatar.png', restaurantName: 'Zatar' },
    { src: '/storage/img/partner-logos/armenia.jpg', restaurantName: 'Armenia', addonClass: 'logo-long' },
    { src: '/storage/img/partner-logos/chrupko.jpg', restaurantName: 'Chrupko' },
    { src: '/storage/img/partner-logos/bianca-e-livia.jpg', restaurantName: 'Bianca e Livia' },
    { src: '/storage/img/partner-logos/u-szewca.jpg', restaurantName: 'U Szewca' },
    { src: '/storage/img/partner-logos/niepospolita.png', restaurantName: 'Niepospolita' },
    { src: '/storage/img/partner-logos/tutti-gusti.jpg', restaurantName: 'Tutti Gusti' }
];
export var reservationPartners = [
    { src: '/storage/img/partner-logos/kawa-i-lawa.png', restaurantName: 'Kawa i Ława' },
    { src: '/storage/img/partner-logos/boru.png', restaurantName: 'Boru Ramen Shop' },
    { src: '/storage/img/partner-logos/zielony-talerzyk2.png', restaurantName: 'Zielony Talerzyk', addonClass: 'logo-long' },
    { src: '/storage/img/partner-logos/u-szewca.jpg', restaurantName: 'U Szewca' },
    { src: '/storage/img/partner-logos/niepospolita.png', restaurantName: 'Niepospolita' },
    { src: '/storage/img/partner-logos/padbar.jpg', restaurantName: 'Padbar' },
    { src: '/storage/img/partner-logos/trybunalska.jpg', restaurantName: 'Trybunalska' },
    { src: '/storage/img/partner-logos/legendy-miasta.jpg', restaurantName: 'Legendy Miasta' },
    { src: '/storage/img/partner-logos/male-indie.jpg', restaurantName: 'Małe Indie' },
];
export var LUBJEpartners = [
    { src: '/storage/img/partner-logos/chisza.jpg', restaurantName: 'Chisza' },
    { src: '/storage/img/partner-logos/bombardino-icon.jpg', restaurantName: 'Bombardino Delivery' },
    { src: '/storage/img/partner-logos/jesz-burger.svg', restaurantName: 'Jesz Burger' },
    { src: '/storage/img/partner-logos/viva-la-pizza.png', restaurantName: 'Viva La Pizza' },
    // { src: '/storage/img/partner-logos/piri-piri.jpg', restaurantName: 'Piri Piri' },
    { src: '/storage/img/partner-logos/czarna-owca.jpg', restaurantName: 'Czarna Owca Gastro Pub' },
    { src: '/storage/img/partner-logos/zatar.png', restaurantName: 'Zatar' },
    { src: '/storage/img/partner-logos/bianca-e-livia.jpg', restaurantName: 'Bianca e Livia' },
    { src: '/storage/img/partner-logos/u-szewca.jpg', restaurantName: 'U Szewca' },
    { src: '/storage/img/partner-logos/tutti-gusti.jpg', restaurantName: 'Tutti Gusti' }
];
